import { connect } from "react-redux";
import { State } from "../../../store";
import { profile } from "store/profile";
import { global } from "store/global";
import { router } from "store/router";
import { organization } from "store/organization";

const mapStateToProps = (state: State) => ({
  organizationRefs: global.selectors.organizationRefs(state),
  carrierRefs: global.selectors.carrierRefs(state),
  operatorRefs: global.selectors.operatorRefs(state),
  currentUser: profile.selectors.User(state),
  organization: organization.selectors.organization(state),
});

const mapDispatchToProps = {
  goToDashboard: router.goto.dashboard,
  fetchOrganization: organization.queries.fetchOrganization,
};

export default connect(mapStateToProps, mapDispatchToProps);
